import $ from 'jquery';

const Form = {
	fieldsListener : function(form) {
		$(form +' input, ' + form +' select, '+ form +' textarea ').on('change keyup paste', function () {
			$(this).parents('.form-group, .form-check').removeClass('has-error has-feedback');
			$(this).parents('.form-group, .form-check').find('.help-block').remove();
		});
	},
	clearError : function(el) {
		$(el).parents('.form-group, .form-check').removeClass('has-error has-feedback');
		$(el).parents('.form-group, .form-check').find('.help-block').remove();
		$(el).parents('.form-group, .form-check').find('.filename').remove();
		// input file case:
		$(el).parents('.form-group, .form-check').find('.box-input-file').removeClass('uploadOn');
		$(el).parents('.form-group, .form-check').find('.progress-bar').css('width','0px');
		$(el).parents('.form-group, .form-check').find('.progress-status').html('0%');
	},
	clearAllErrors : function(form) {
		$(el+' .form-group').removeClass('has-error has-feedback');
		$(el+' .form-group .help-block').remove();
	},
	addError : function(el,msg) {
		Form.clearError(el);


		$(el).parents('.form-group, .form-check').addClass('has-error has-feedback');

		if (typeof msg === 'object' || typeof msg === 'array') {

			for(let err of msg){

				$(el).parents('.form-group, .form-check').append('<div class="help-block">'+err+'</div>');
			}
		} else {
            $(el).parents('.form-group, .form-check').append('<div class="help-block">'+msg+'</div>');
		}
	}
};

export default Form;


// WEBPACK FOOTER //
// ./src/js/inc/form-errors.js